import { black, primary, secondary, white } from "@/styles/variable"
import styled from "styled-components"

export const MySessionCardContainer = styled.div`
  width: 100%;
  align-self: stretch;
  border-radius: 24px;
  border: 1px solid ${secondary.background_black05};
  background: ${black[18]};
  padding: 20px;
`

export const MySessionCardHeader = styled.div`
  margin-bottom: 12px;
`
export const MySessionGroupTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  span {
    color: ${primary.white};
  }
`

export const MySessionCardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const MySessionCardTitle = styled.div`
  width: 100%;
  margin-bottom: 6px;
`
export const MySessionCardTitleText = styled.p<{
  lineclamp?: number
}>`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${props => props.lineclamp};
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.5px;
`

export const MySessionCardDesc = styled.div`
  width: 100%;
`

export const MySessionCardDescText = styled.p`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: ${white[40]};
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 17px; /* 141% */
  letter-spacing: -0.36px;
`

export const MySessionCardFooter = styled.div`
  height: auto;
`
